import React, { useRef, useState } from 'react'
import WebSec1 from '../sections/WebSec1'
import WebSec2 from '../sections/WebSec2'
import WebSec3 from '../sections/WebSec3'
import { WebSec4 } from '../sections/WebSec4'
import HomeNinthSection from '../sections/HomeNinthSection'
import { AwardsComponent } from './Home'
import { useServiceData } from '../context/ServiceDataContext'
import ServicesShowcase from '../components/ServicesShowcase'

const WebAndDigital = () => {
    const { getServiceById, getServiceByCategory } = useServiceData();
    // const webServices = getServiceByCategory(`${pathname.split("/")[1]}`);
    const webServices = getServiceByCategory(`technology`);

    // const {pathname} = useLocation();

    console.log(webServices);

    return (
        <>
            <AwardsComponent />
            <div className='min-h-screen relative z-10 w-full dark:text-white dark:bg-transparent bg-white'>
                <WebSec1 />

                <WebSec3 />
                <ServicesShowcase data={webServices} superData={webServices} />

                <WebSec2 />

                {/* <WebSec4 /> */}
                

                <HomeNinthSection />


            </div >
        </>
    )
}

export default WebAndDigital